import styled from 'styled-components/macro';

export const HighlightEditButtons = styled.div`
  display: flex;
  align-items: center;
  overflow: visible;
  gap: 1rem;
  height: min-content;
`;
